import {
    ERROR_GET_GIFT_DATA_PACKAGES_DETAILS,
    GET_GIFT_DATA_PACKAGES_DETAILS, 
    SUCCESS_GET_GIFT_DATA_PACKAGES_DETAILS
}  from '../../Types'

const initialState = {
    loading: true,
    dataBundle: {},
    error: ''
}

export default function giftDataDetailsReducer(state = initialState, action) {
    switch (action.type) {

        case GET_GIFT_DATA_PACKAGES_DETAILS : {
            return {
                ...state,
                loading: true
            }
        }

        case SUCCESS_GET_GIFT_DATA_PACKAGES_DETAILS : {
            return {
                ...state,
                loading: false,
                dataBundle: action.payload
            }
        }

        case ERROR_GET_GIFT_DATA_PACKAGES_DETAILS : {
            return {
                loading: false,
                error: action.payload
            }
        }

        default :
            return state
    }
}
